import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from '@fluentui/react-components';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {useSelector} from "react-redux";
import {RootState} from "../../Store/Store";
import { useLocalization } from '../Helpers/useLocalization';

interface IAddedToCartDialogProps {
    open: boolean;
    onClose: (isOpen:boolean) => void;
    label?: string;
}

const AddedToCartDialog: React.FC<IAddedToCartDialogProps> = (props) => {
    const settings = useSelector((state: RootState) => state.cart);
    const nav = useNavigate();
    const L = useLocalization();
    const [postCloseNavigate, setPostCloseNavigate] = React.useState<boolean>(false)
    
    React.useEffect(() => {
        if(postCloseNavigate){
            setPostCloseNavigate(false)
            if(settings.selectedCartId){
                nav(`/prepared-cart/${settings.selectedCartId}`);
            }
            else {
                nav('/cart');
            }
        }
    }, [postCloseNavigate, nav, settings.selectedCartId])
    
    const navToCart = () => {
        close()
        setPostCloseNavigate(true)
    }
    
    const close = () => {
        props.onClose(false);
    }

    return (<Dialog
        open={props.open}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{L('localization_cart_added_dialog_title')}</DialogTitle>
                    <DialogContent>{props.label ?? L('localization_cart_added_default_item')} {L('localization_cart_added_dialog_body')}</DialogContent>
                    <DialogActions>
                        <Button onClick={close}>{L('localization_common_continue_shopping')}</Button>
                        <Button appearance='primary' onClick={navToCart}>{L('localization_common_go_to_cart')}</Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}

export default AddedToCartDialog;